/**
 * Constantes de Horarios y de sus Rangos.
 *
 * `rangos/` vive adentro de esta carpeta y importa de acá: un rango no existe suelto,
 * siempre cuelga de un horario, así que el vocabulario es uno solo.
 *
 * Los regex vivían exportados desde `Horarios.jsx` y los modales los importaban
 * de la vista. Eso ataba el modal a la página que lo abre; acá no depende de nada.
 */

// NO hay regex para nombre ni descripcion, y es a proposito.
//
// Las vistas llegaron con uno heredado de MIA Key que solo admitia letras, numeros,
// las cinco vocales acentuadas, la enie, el espacio y unos pocos separadores. Eso es
// un formato de CODIGO, no de prosa: rechazaba la coma, los parentesis, el punto y
// coma, el porcentaje, la dieresis y los signos de pregunta. "Jornada de oficina, de
// lunes a viernes" no pasaba.
//
// El resto de los ABM del modulo —funciones, agrupamientos, titulos, cargos— valida
// solo largo y requerido. Estos ahora tambien.

// El codigo SI es una clave: sin espacios ni separadores.
export const codRegex = /^[A-Za-z0-9ñÑ.]+$/;

export const LARGO_HORARIO = {
    nombre: 45,
    descripcion: 255,
    cod: 15,
};

/**
 * Días de la semana, en el orden en que se leen.
 *
 * El `cod` es lo que guarda el rango y además es el `field` de la columna del grid
 * (ver `rangosTitles`), así que la fila se arma sin tabla de traducción en el medio.
 */
export const DIAS = [
    { cod: "LU", label: "Lu", param: "lunes", campo: "rnhHorarioRangoLunes" },
    { cod: "MA", label: "Ma", param: "martes", campo: "rnhHorarioRangoMartes" },
    { cod: "MI", label: "Mi", param: "miercoles", campo: "rnhHorarioRangoMiercoles" },
    { cod: "JU", label: "Ju", param: "jueves", campo: "rnhHorarioRangoJueves" },
    { cod: "VI", label: "Vi", param: "viernes", campo: "rnhHorarioRangoViernes" },
    { cod: "SA", label: "Sa", param: "sabado", campo: "rnhHorarioRangoSabado" },
    { cod: "DO", label: "Do", param: "domingo", campo: "rnhHorarioRangoDomingo" },
];

/**
 * Los dos vocabularios de un día, y por qué conviven.
 *
 * El FRONT maneja un array de códigos —`["LU","MI"]`— porque es lo que el selector de
 * días y la grilla necesitan: un conjunto. El BACK maneja siete campos sueltos en
 * "Y"/"N", uno por día, con nombre en español.
 *
 * Las dos traducciones viven acá y no en los modales para que el día que cambie un
 * nombre haya un solo lugar que tocar. `DIAS` es la tabla: `param` es cómo lo pide el
 * servicio y `campo` cómo vuelve en la response.
 */

/** `["LU","MI"]` -> `{ lunes: "Y", martes: "N", ... }`, los SIETE siempre. */
export const diasAParams = (dias = []) =>
    Object.fromEntries(
        DIAS.map(({ cod, param }) => [param, dias.includes(cod) ? "Y" : "N"])
    );

/** Una fila de la response -> `["LU","MI"]`, en el orden de la semana. */
export const paramsADias = (fila) =>
    DIAS.filter(({ campo }) => fila?.[campo] === "Y").map(({ cod }) => cod);
